import { useKindeAuth } from '@kinde-oss/kinde-auth-react'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router'

import type { CardholderSummary } from '@ankor-io/common/types/cards'

import { useUserContext } from '@/providers/user/useUserContext'
import Loading from '@/ui-components/Loading'
import { CardSpend } from '@/views/Cards/CardSpend'
import MainCardholderDetails from '@/views/ViewCardholderDetails/MainCardholderDetails'

export const ViewCardholderDetailsPage = () => {
  const { cardholderId } = useParams()
  const { getAccessToken } = useKindeAuth()
  const { activeOrganizationId, activeConnectedAccountId } = useUserContext()
  const [isLoading, setIsLoading] = useState(true)
  const [cardholder, setCardholder] = useState<CardholderSummary | null>(null)

  useEffect(() => {
    const getCardholder = async () => {
      setIsLoading(true)
      try {
        const res = await fetch(
          `/api/pay/org/${activeOrganizationId}/connected-account/${activeConnectedAccountId}/cardholder/${cardholderId}`,
          {
            headers: {
              Authorization: `Bearer ${await getAccessToken()}`,
            },
          },
        )

        if (!res.ok) {
          throw new Error('Failed to fetch cardholder')
        }

        const data = await res.json()

        setCardholder(data.cardholder)
      } catch (error) {
        console.error(error)
      } finally {
        setIsLoading(false)
      }
    }

    getCardholder()
  }, [cardholderId, getAccessToken, activeOrganizationId, activeConnectedAccountId])

  if (isLoading) {
    return <Loading />
  }

  // No cardholderId and loading is finished
  if (!cardholderId || !cardholder) {
    return <div>No cardholder found</div>
  }

  return (
    <div
      className="w-full flex flex-col xl:flex-row gap-8"
      data-testid="view-cardholder-details-page"
    >
      <MainCardholderDetails cardholder={cardholder} />
      <CardSpend />
    </div>
  )
}

export default ViewCardholderDetailsPage
